module.exports = __webpack_public_path__ + "img/SIA-alt.9d7ee810.svg";